import { CommonModels } from './common.models';

export namespace AuthenticationModels {
  export class Account {
    id!: number;
    impersonatorAccountId!: number;
    firstName!: string;
    lastName!: string;
    email!: string;
    login!: string;
    kind!: number;
    rights!: number[];
    backOfficeAuto?: boolean;
    backOfficeSante?: boolean;

    hasRight(right: number) {
      return this.rights.indexOf(right) !== -1;
    }
  }

  export class Broker extends Account {
    agencyId!: number;
    phoneNumber!: string;
    mobileNumber!: string;
    isHeadOfAgency!: boolean;
    civility!: CommonModels.CivilityEnum;
    hasAgeoAccount!: boolean;
    contactId!: number;
  }

  export class Client extends Account {}

  export enum AccountStatus {
    Online = 1,
    Offline,
  }

  export enum RightEnum {
    ReadAgencySubscription = 1,
    EditAgencySubscription = 2,
    SignAgencySubscription = 3,
    ValidAgencySubscription = 4,
    AffectUnassignedEmail = 5,
    AccessBrokerApp = 6,
    CallBroker = 7,
    ManageAgencyEmail = 8,
    ReadQuotation = 9,
    EditQuotation = 10,
    EditHeadOfAgency = 11,
    RemoveAgencyInSubscription = 12,
    ArchiveQuotation = 13,
    GenerateAgencyHealthFile = 14,
    EditHealthRate = 15,
    GenerateAgenciesExportFile = 16,
    UnarchiveAgency = 17,
    ReadAgencyCommissions = 18,
    ReadAgencyDetails = 19,
    ReadSubBrokers = 20,
    CreateSubBroker = 21,
    ArchiveSubBroker = 22,
    GenerateApiCredentials = 23,
    ReadApiCredentials = 24,
    CreateHandlingBroker = 25,
    ArchivHandlingBroker = 26,
    EditAutoRate = 27,
    ReadAgency = 28,
    PayReceipts = 29,
    UpdateMainBrokerEmail = 30,
    EditRopRate = 32,
    ReadClientData = 100,
    UploadPolicyFile = 101,
    ManagePolicyFile = 102,
    EditPolicy = 103,
    ActivatePolicy = 104,
    HandleComplement = 105,
    ReadSinister = 106,
    ManageSinister = 107,
    CreateReleveInformation = 108,
    CreateTerminationRequest = 109,
    ManageTerminationRequest = 110,
    CancelTerminationRequest = 111,
    ReadPolicyTerminationRequest = 112,
    UpdatePolicyQuantieme = 113,
    CreateAvenantRequest = 114,
    ReadAvenantRequest = 115,
    ManageAvenantRequest = 116,
    SetCaducite = 117,
    SetNullite = 118,
    FinGarantieProvisoire = 119,
    RemoveReceiptFees = 120,
    CreateComments = 121,
    ReadComments = 122,
    ReadIssuedRefunds = 123,
    MarkReceiptsToRefund = 124,
    CancelPendingRefund = 125,
    ActivateHealthPolicyWithoutDocuments = 126,
    RollbackTermination = 127,
    CreateAvenantGestion = 129,
    AddMiscRefund = 130,
    ReadPolicyHistory = 131,
    AddHealthMiscRefundAdmin = 132,
    SelectPayableReceipt = 133,
    SetNoEffect = 134,
    CancelBeforeAccounting = 135,
    RelanceSignatureCp = 136,

    CreateAllAvenantRequest = 138,
    ManageClaimComment = 139,

    ReadBrokerPolicyStats = 1001,
    EditProductRights = 1002,

    AutoProduct = 2001,
    InfinityProduct = 2002,
    RopProduct = 2003,
    FidelityProduct = 2004,
    AcheelProduct = 2005,

    // TunnelSante
    AccessInternalBackoffice = 5000,
    AccessAdministrationHealth = 5100,
    ImportHealthDirectDebitsFile = 5101,
    ImportHealthRejectsFile = 5102,
    CanOverrideControls = 5105,
    AccessInternalAdminSettings = 6000,
    ReadAccount = 6001,
    UpdateSetting = 6003,
    ReadSetting = 6004,
    ImpersonateBroker = 6005,

    ReadSlipRequests = 6006,
    CreateSlipRequests = 6007,
    EditSlipRequests = 6008,
    DeleteSlipRequests = 6009,
    ManageComment = 6010,
    ReadStat = 6011,
  }

  export enum RoleEnum {
    BrokerSubscriber = 101,
    MainBroker = 102,
    BrokerPendingSignature = 103,
    AgencyMailOperator = 1001,
    AgencyOperator = 1002,
    ClientOperator = 1003,
    ClientManager = 1004,
    AutoBroker = 104,
    InfinityBroker = 105,
    BusinessManager = 1005,
    HealthAdmin = 1006,
    RefundAdmin = 1007,
    SubBroker = 106,
    AgencyManager = 1008,
    Director = 1009,
    HandlingBroker = 107,
    AccountAdmin = 2000,
    SettingAdmin = 2001,
    ReadOnlyAuto = 1010,
    BackOfficeManager = 1011,
    HandlingSubBroker = 108,
    SubBrokerQuotationOnly = 109,
    AddMiscRefundAdmin = 1012,
    AddHealthMiscRefundAdmin = 1013,
    MainBrokerAdmin = 1014,
    FinancialAdmin = 1015,
    RopBroker = 110,
    CancelActionAdmin = 1016,
    SuperAdmin = 2002,
    FidelityBroker = 111,
    AcheelBroker = 112,
    ClaimCommentAdmin = 1017,
    HealthPolicyControllerLevel1 = 1018,
    HealthPolicyControllerLevel2 = 1019,
    HealthPolicyControllerLevel3 = 1020,
    HealthTerminationRequestManager = 1021,
    HealthOperator,
    AutoOperator,
    CommentAdmin = 2003,
    StatAdmin = 2004,
  }
}
